import { Link } from "react-router-dom";
import { comics, getCategoryName } from "@/mocks/comics";

export default function Ranking() {
  const top = [...comics].sort((a, b) => b.rating - a.rating).slice(0, 5);

  return (
    <section className="bg-background-100">
      <div className="container-site grid gap-10 py-16 md:grid-cols-5 md:py-20">
        <div className="md:col-span-2">
          <p className="inline-flex items-center gap-2 text-xs font-medium text-accent-600">
            <i className="ri-medal-fill"></i>
            人气总榜
          </p>
          <h2 className="mt-2 text-2xl font-semibold text-foreground-950 md:text-3xl">
            大家都在追
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            实时更新全站人气与评分,热门漫画一目了然。点击即可进入高清阅读,感受舒适追漫体验。
          </p>
          <Link
            to="/category/all"
            className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-secondary-600 cursor-pointer"
          >
            去分类逛逛
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex flex-col gap-4 md:col-span-3">
          {top.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex items-center gap-4 rounded-lg bg-background-50 p-3 transition-colors hover:bg-background-200/70"
            >
              <span
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-lg font-bold ${
                  idx < 3
                    ? "bg-accent-500 text-background-50"
                    : "bg-secondary-100 text-secondary-900"
                }`}
              >
                {idx + 1}
              </span>
              <img
                src={comic.cover}
                alt={`${comic.title} 封面`}
                className="h-16 w-12 shrink-0 rounded-md object-cover object-top"
              />
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-500 md:text-base">
                  {comic.title}
                </h3>
                <p className="mt-0.5 truncate text-xs text-foreground-600">
                  {getCategoryName(comic.category)} · {comic.author}
                </p>
              </div>
              <div className="flex shrink-0 flex-col items-end gap-1">
                <span className="flex items-center gap-1 text-xs font-semibold text-accent-600">
                  <i className="ri-star-fill"></i>
                  {comic.rating.toFixed(1)}
                </span>
                <span className="text-xs text-foreground-500">{comic.views}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}